import { StaticDataObject } from "context/staticData/staticData";

import { Column } from "react-table";
import CellEllipsis from "shared/core/Table/components/cellEllipsis";
import { Copies } from "shared/hooks/useCopies";
import { ApiParticipantReimbursementAdminForListing } from "shared/types/ApiParticipantReimbursementAdminForListing";

export const fixedColumns = ["name"];

export function getTableColumnsForReimbursement({
  copies,
  staticDataObj
}: {
  copies: Copies;
  staticDataObj: StaticDataObject;
}): Array<Column<ApiParticipantReimbursementAdminForListing>> {
  return [
    {
      id: "name",
      Header: copies.get("name"),
      accessor: ({ firstName, lastName }) => `${firstName} ${lastName}`,
      width: 180,
      Cell: CellEllipsis
    },
    {
      id: "workEmail",
      Header: copies.get("work.email"),
      accessor: "workEmail",
      width: 200,
      Cell: CellEllipsis
    },

    {
      id: "organizationName",
      Header: copies.get("organization.name"),
      accessor: "organizationName",
      width: 150,
      Cell: CellEllipsis
    },

    {
      id: "tag",
      Header: copies.get("tags"),
      accessor: d => d.programParticipantTags?.map(tag => staticDataObj.programParticipantTag[tag]).join(", "),
      width: 150,
      Cell: CellEllipsis
    },
    {
      id: "status",
      Header: copies.get("status"),
      accessor: d => staticDataObj.reimbursementStatus?.[d.reimbursementStatus],
      width: 150,
      Cell: CellEllipsis
    },
    {
      id: "adminNote",
      Header: copies.get("admin.note"),
      accessor: "adminNote",
      width: 150,
      Cell: CellEllipsis
    }
  ];
}
